import React from 'react'
import { reducer, initialState } from './reducer'

export const CostChangeInsightsPageContext = React.createContext({
  costChangeInsightsPageState: initialState,
  costChangeInsightsPageDispatch: () => null,
})

export const CostChangeInsightsPageProvider = ({ children }) => {
  const [costChangeInsightsPageState, costChangeInsightsPageDispatch] =
    React.useReducer(reducer, initialState)

  return (
    <CostChangeInsightsPageContext.Provider
      value={[costChangeInsightsPageState, costChangeInsightsPageDispatch]}
    >
      {children}
    </CostChangeInsightsPageContext.Provider>
  )
}
